import { TaskAlt } from '@mui/icons-material';

const Task = (): JSX.Element => <TaskAlt fontSize="inherit" />;

export default Task;
